// extracted by mini-css-extract-plugin
export default {"assessment_setup":"AssessmentSetup_assessment_setup__wL8kx","form_select":"AssessmentSetup_form_select__jl82+"};